import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
const useBindChangeLocaleEvent = () => {
    const { i18n } = useTranslation();
    useEffect(() => {
        const onLocaleChange = ({ detail: language }) => i18n.changeLanguage(language);
        // @ts-ignore
        window.addEventListener('change-locale', onLocaleChange);
        // @ts-ignore
        return () => window.removeEventListener('change-locale', onLocaleChange);
    });
};
export default useBindChangeLocaleEvent;
